import styled from "styled-components";
import { motion } from "framer-motion";

export const CardDisplayLargeContainer = styled(motion.div)`
    align-items: center;
    display: flex;
    gap: ${({ orientation }) => orientation !== "horizontal" ? '20px' : '64px'};
    justify-content: center;
    position: relative;
    transition: transform 0.1s ease, gap 0.3s ease;
    width: 100%;
`;
export const ContentContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: ${({ $orientation }) => $orientation === 'horizontal' ? 'column' : 'row'};
    gap: 24px;
    width: 100%;
`
export const LeftOverlayContent = styled.div`
    align-items: ${({ $orientation }) => $orientation === 'horizontal' ? 'center' : 'end'};
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    h1 {
        font-family: 'Roboto Condensed';
        font-size: 20px;
        opacity: 0.8;
    }
`;
export const CardHoverActions = styled.div`
    align-items: stretch;
    bottom: calc(100% + 12px);
    display: flex;
    flex-direction: column;
    gap: 8px;
    left: 0;
    opacity: ${({ $visible }) => ($visible ? 1 : 0)};
    pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
    position: absolute;
    right: 0;
    transition: opacity 0.2s ease;
    z-index: 2;

    &::before {
        bottom: -12px;
        content: '';
        height: 12px;
        left: 0;
        position: absolute;
        right: 0;
    }
`

export const CardImageFrame = styled.div`
    flex-shrink: 0;
    position: relative;

    &:hover ${CardHoverActions} {
        opacity: 1;
        pointer-events: auto;
    }
`

export const CardTilt = styled.div`
    perspective: 900px;
    width: 100%;
`

export const CardTiltSurface = styled.div`
    position: relative;
    transform: rotateX(0deg) rotateY(0deg);
    transform-style: preserve-3d;
    transition: transform 0.45s cubic-bezier(0.22, 1, 0.36, 1);
`

export const ImgContainer = styled.div`
    align-items: center;
    align-self: center;
    background: ${({ $hasUploadedImage }) => $hasUploadedImage ? 'transparent' : 'rgba(255,255,255,0.1)'};
    backdrop-filter: ${({ $hasUploadedImage }) => $hasUploadedImage ? 'none' : 'blur(8px)'};
    -webkit-backdrop-filter: ${({ $hasUploadedImage }) => $hasUploadedImage ? 'none' : 'blur(8px)'};
    border: ${({ $hasUploadedImage }) => $hasUploadedImage ? 'none' : '1px solid rgba(255,255,255,0.1)'};
    border-radius: 2px;
    display: flex;
    flex-shrink: 0;
    height: ${({ orientation }) => orientation === "horizontal" ? '256px' : '352px'};
    justify-content: center;
    overflow: hidden;
    position: relative;
    transition: height 0.3s ease, width 0.3s ease, background 0.3s ease, border 0.3s ease;
    width: ${({ orientation }) => orientation === "horizontal" ? '352px' : '256px'};

    img {
        height: ${({ orientation, $hasUploadedImage }) => orientation === "horizontal" ? '352px' : ($hasUploadedImage ? '100%' : 'auto')};
        left: ${({ orientation }) => orientation === 'horizontal' ? '50%' : 'auto'};
        object-fit: contain;
        opacity: ${({ $hasUploadedImage }) => $hasUploadedImage ? '1' : '0.4'};
        position: ${({ orientation }) => orientation === 'horizontal' ? 'absolute' : 'static'};
        top: ${({ orientation }) => orientation === 'horizontal' ? '50%' : 'auto'};
        transform: ${({ orientation }) => orientation === 'horizontal' ? 'translate(-50%, -50%) rotate(90deg)' : 'none'};
        width: ${({ orientation, $hasUploadedImage }) => orientation === "horizontal" ? '256px' : ($hasUploadedImage ? '100%' : '40%')};
    }
`;

export const RightOverlayContent = styled.div`
    align-items: ${({ $orientation }) => $orientation === 'horizontal' ? 'center' : 'start'};
    display: flex;
    flex-direction: ${({ $orientation }) => $orientation === 'horizontal' ? 'row' : 'column'};
    flex-wrap: wrap;
    gap: 8px;
    justify-content: center;
    width: 100%;
`;